import { Injectable } from "@angular/core";
import { BodyOutputType, Toast, ToasterService } from "angular2-toaster";
import { HttpErrorResponse } from "@angular/common/http";

@Injectable({
  providedIn: "root"
})
export class ToastNotificationService {
  constructor(public toasterService: ToasterService) {
  }

  showError(message: string = "mislukt", title: string = "Fout!") {
    const toast: Toast = {
      type: "error",
      title: title,
      body: message,
      timeout: 10000,
      showCloseButton: true,
      bodyOutputType: BodyOutputType.TrustedHtml
    };
    this.toasterService.popAsync(toast);
  }

  showSuccess(message: string = "kennisgeving", title: string = "succes") {
    const toast: Toast = {
      type: "success",
      title: title,
      body: message,
      timeout: 10000,
      showCloseButton: true,
      bodyOutputType: BodyOutputType.TrustedHtml
    };
    this.toasterService.popAsync(toast);
  }

  showInfo(message: string = "kennisgeving", title: string = "") {
    const toast: Toast = {
      type: "info",
      title: title,
      body: message,
      timeout: 10000,
      showCloseButton: true,
      bodyOutputType: BodyOutputType.TrustedHtml
    };
    this.toasterService.popAsync(toast);
  }

  handleResponse(promise: Promise<any>, callback: ((status, error) => string) = ((status, error) => error), successText = 'succes') {
    const vm = this;
    promise
      .then(res => {
        callback(200, res);
        if (res && "errors" in res && res["errors"].length !== 0) {
          for (const error in res["errors"]) {
            if (res["errors"].hasOwnProperty(error)) {
              for (const message of res["errors"][error]) {
                vm.showError(message);
              }
            }
          }
          // vm.showError(res["message"]);
        } else {
          if (res) {
            vm.showSuccess(res["message"]);
          } else {
            vm.showSuccess(successText);
          }
        }
        return res;
      })
      .catch((reason: HttpErrorResponse) => {
        let error = 'Error! ' + reason.message;
        if (reason.status === 413) {
          error = 'Uploadlimiet bereikt.';
        }
        if (reason.status === 400) {
          error = 'Invalid user';
        }
        error = callback(200, error);
        vm.showError(error);
      });
  }
}
